 export enum EtatDeclarationOeth {
NonCreee = 0,
EnCours = 1,
Preparee = 2,
IntegreeDsn = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/EtatDeclarationOeth.ts